<template>
  <div class="h-row-top">
    <div class="h-row-top grow-1">
      <div>
        <div class="inline-detail">
          <label>Módulo</label>
          <div>
            <router-link :to="`/clients/${clientId}`">
              {{ clientId }}
            </router-link>
          </div>
        </div>
        <div class="inline-detail">
          <label>ID do mailbox</label>
          <div>
            {{ mbB.mailboxId }}
          </div>
        </div>
      </div>

      <div>
        <div
          class="inline-detail"
          :key="row[0]"
          v-for="row in [
            ['Criado', mbB.createdAt],
            ['Entregue', mbB.deliveredAt],
            ['Cancelado', mbB.deletedAt]
          ]"
        >
          <label>{{ row[0] }}</label>
          <div>{{ row[1] | moment }}</div>
        </div>
      </div>
    </div>

    <v-divider vertical class="mx-6" />

    <div class="h-row-top grow-1">
      <div>
        <div class="inline-detail">
          <label>Módulo</label>
          <div>
            <router-link :to="`/clients/${clientId}`">
              {{ clientId }}
            </router-link>
          </div>
        </div>
        <div class="inline-detail">
          <label>ID do mailbox</label>
          <div>
            {{ mbA.mailboxId }}
          </div>
        </div>
      </div>

      <div>
        <div
          class="inline-detail"
          :key="row[0]"
          v-for="row in [
            ['Criado', mbA.createdAt],
            ['Entregue', mbA.deliveredAt],
            ['Cancelado', mbA.deletedAt]
          ]"
        >
          <label>{{ row[0] }}</label>
          <div>{{ row[1] | moment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    vehicle: {},
    mbB: {},
    mbA: {}
  },
  computed: {
    clientId() {
      let cid = _.get(this.mbB, 'clientId')
      if (cid == null) cid = _.get(this.mbA, 'clientId')
      if (cid == null) cid = _.get(this.mbB, 'vehicle.clientId')
      if (cid == null) cid = _.get(this.mbA, 'vehicle.clientId')
      return cid
    }
  }
}
</script>

<style lang="sass">
.inline-detail
  display: flex
  flex-flow: row nowrap

  label
    width: 100px
    text-align: right
    margin-right: 8px
    color: #757575
</style>
